<template>
  <div>
    <br />
    <!--donation page start -->
    <div class="container">
      <div class="row">
        <div class="col-md-4 col-xs-12">
          <div class="donate-left-section">
            <img :src="studentData.student_image" :alt="studentData.name" />
            <br /><br />
            <h4>
              <b>{{ studentData.name }}</b>
            </h4>
            <p>{{ studentData.biography }}</p>
          </div>
        </div>

        <div class="col-md-8 col-xs-12">
          <p class="donate-title">SPONSOR NOW</p>
          <div class="row">
            <div class="col-md-2 col-4 p-1" key="1">
              <p
                :class="{
                  active:
                    selectedamount ==
                    parseInt((studentData.scholarship_amount / 12) * 1),
                }"
                class="price-value tool"
                data-tip="Sponsor For 1 Month"
                @click="
                  loadAmount(
                    parseInt((studentData.scholarship_amount / 12) * 1)
                  )
                "
              >
                ৳ {{ parseInt((studentData.scholarship_amount / 12) * 1) }}
              </p>
            </div>
            <div class="col-md-2 col-4 p-1" key="2">
              <p
                :class="{
                  active:
                    selectedamount ==
                    parseInt((studentData.scholarship_amount / 12) * 3),
                }"
                class="price-value tool"
                data-tip="Sponsor For 3 Months"
                @click="
                  loadAmount(
                    parseInt((studentData.scholarship_amount / 12) * 3)
                  )
                "
              >
                ৳ {{ parseInt((studentData.scholarship_amount / 12) * 3) }}
              </p>
            </div>

            <div class="col-md-2 col-4 p-1" key="3">
              <p
                :class="{
                  active:
                    selectedamount ==
                    parseInt((studentData.scholarship_amount / 12) * 6),
                }"
                class="price-value tool"
                data-tip="Sponsor For 6 Months"
                @click="
                  loadAmount(
                    parseInt((studentData.scholarship_amount / 12) * 6)
                  )
                "
              >
                ৳ {{ parseInt((studentData.scholarship_amount / 12) * 6) }}
              </p>
            </div>

            <div class="col-md-2 col-4 p-1" key="4">
              <p
                :class="{
                  active:
                    selectedamount ==
                    parseInt((studentData.scholarship_amount / 12) * 9),
                }"
                class="price-value tool"
                data-tip="Sponsor For 9 Months"
                @click="
                  loadAmount(
                    parseInt((studentData.scholarship_amount / 12) * 9)
                  )
                "
              >
                ৳ {{ parseInt((studentData.scholarship_amount / 12) * 9) }}
              </p>
            </div>

            <div class="col-md-2 col-4 p-1" key="5">
              <p
                :class="{
                  active:
                    selectedamount ==
                    parseInt((studentData.scholarship_amount / 12) * 12),
                }"
                class="price-value tool"
                data-tip="Sponsor For 1 Year"
                @click="
                  loadAmount(
                    parseInt((studentData.scholarship_amount / 12) * 12)
                  )
                "
              >
                ৳ {{ parseInt((studentData.scholarship_amount / 12) * 12) }}
              </p>
            </div>

            <div class="col-md-2 col-4 p-1">
              <input
                type="text"
                placeholder="TYPE AMOUNT"
                name=""
                class="customer-donation-input customer-donation"
                v-model="other_amount"
                @keyup="customAmount"
                style="padding-left:8px"
              />
            </div>

            <div class="col-md-12 col-12 p-1">
              <textarea
                class="customer-donation-input customer-donation"
                placeholder="ENTER YOUR MESSAGE"
                v-model="comments"
                style="margin-top: 15px; height: 100px; padding-top: 10px;"
              ></textarea>

              <!-- <input
                class="customer-donation-input customer-donation"
                placeholder="ENTER YOUR MESSAGE"
                v-model="comments"
                style="margin-top: 15px;"
              /> -->
            </div>
          </div>
          <br />
          <label class="checkbox-inline" @click="donorInfo">
            <input type="checkbox" name="" /> &nbsp;
            <span @click="donorInfo">I WANT TO PROVIDE MY INFORMATION</span>
          </label>
          <br />
          <div class="row" v-if="show">
            <div class="col-md-6 col-6 p-1">
              <input
                type="text"
                placeholder="Your Name"
                class="customer-donation-input customer-donation"
                v-model="cus_name"
              />
            </div>
            <div class="col-md-6 col-6 p-1">
              <input
                type="text"
                placeholder="Contact Number"
                class="customer-donation-input customer-donation"
                v-model="cus_phone"
              />
            </div>
            <div class="col-md-12 col-12 p-1">
              <input
                type="text"
                placeholder="Email Address"
                class="customer-donation-input customer-donation"
                v-model="cus_email"
              />
            </div>
          </div>

          <div class="chose-payment">
            <p>
              <span
                style="font-size: 22px; font-weight: 600; margin-right:2rem; "
                >Choose Payment
              </span>
              <span>
                <img src="/assets/images/icon/lock.webp" alt="secure" />
                SECURE</span
              >
            </p>
          </div>

          <div class="row">
            <div class="col-md-6 col-6 p-1" style="display: none;">
              <button class="btn pay-with-btn" @click="formSubmit('ssl')">
                <font-awesome-icon icon="credit-card" />
                Card / Mobile / Bank
              </button>
            </div>

            <div class="col-md-6 col-6 p-1" style="display: none;">
              <button class="btn pay-with-btn" @click="formSubmit('paypal')">
                <font-awesome-icon :icon="['fab', 'paypal']" />
                Paypal
              </button>
            </div>

            <div class="col-md-6 col-12 offset-md-3 p-1">
              <button class="btn pay-with-btn" @click="openModal()">
                Donate Now
              </button>
            </div>
          </div>

          <div class="row" style="display: none;">
            <div class="col-md-12 col-12 p-1">
              <router-link
                :to="{ name: 'BankInfo' }"
                class="btn pay-with-btn additional_bank mt-2 "
                >Additional Bank Information</router-link
              >
            </div>
          </div>
        </div>
        <!--col-md-7 end-->
      </div>
    </div>
    <!--container section-->

    <div id="myModal" class="modal _gallery_">
      <div id="_close_div" class="close_div" @click="closeModal()"></div>
      <div class="modal-content" style="width: 400px; margin-top: 10rem;">
        <span class="close cursor" @click="closeModal()">&times;</span>
        <div
          class="col-md-12"
          style="padding-left: 30px; padding-right: 30px; padding-top: 50px; padding-bottom: 50px;"
        >
          <div class="row">
            <div class="col-md-12 col-12 p-1">
              <button class="btn pay-with-btn" @click="formSubmit('ssl')">
                <font-awesome-icon icon="credit-card" />
                Card / Mobile / Bank
              </button>
            </div>

            <div class="col-md-12 col-12 p-1">
              <button class="btn pay-with-btn" @click="formSubmit('paypal')">
                <font-awesome-icon :icon="['fab', 'paypal']" />
                Paypal
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="donation-payment-option" style="display:none">
      <picture>
        <source
          media="(min-width:650px)"
          srcset="/assets/images/donation/donation-payment-option.webp"
        />
        <source
          media="(min-width:465px)"
          srcset="/assets/images/donation/donate_payment_mobile.webp"
        />
        <img
          src="/assets/images/donation/donate_payment_mobile.webp"
          alt="Flowers"
          style="width:100%;"
        />
      </picture>
    </div>

    <br />
    <br />
    <br />

    <!--donation page end -->
  </div>
</template>

<script>
import swal from "sweetalert";
import axios from "axios";
const apiResourceUrl = process.env.VUE_APP_APIURL;
const adminPanelUrl = process.env.VUE_APP_ADMINPANELURL;
const appRootUrl = process.env.VUE_APP_ROOTURL;
export default {
  name: "SponsorNow",
  data() {
    return {
      selectedamount: "",
      other_amount: "",
      comments: "",
      show: false,
      cus_name: "",
      cus_email: "",
      cus_phone: "",
      currency_bdt: {},
      currency_usd: {},
      studentData: "",
    };
  },
  methods: {
    loadAmount(amount) {
      this.selectedamount = amount;
      //console.log(amount);
    },

    customAmount() {
      this.selectedamount = "";
    },

    donorInfo() {
      if (this.show) {
        this.show = false;
      } else {
        this.show = true;
      }
    },

    openModal() {
      document.getElementById("myModal").style.display = "block";
      document.getElementById("_close_div").style.display = "block";
    },

    closeModal() {
      document.getElementById("myModal").style.display = "none";
    },

    formSubmit(payment_type) {
      if (
        (!this.selectedamount && !this.other_amount) ||
        (!this.selectedamount && this.other_amount < 1)
      ) {
        swal("Amount is required !", "", "error");
        return;
      }

      const form = new FormData();
      form.append("student_id", this.$route.params.id);
      form.append("user_id", localStorage.getItem("userid"));

      var takenAmount = 0;
      if (this.other_amount) {
        takenAmount = this.other_amount;
      } else {
        takenAmount = this.selectedamount;
      }

      form.append("comments", this.comments);
      form.append("donate_way", 3);
      form.append("cus_name", this.cus_name);
      form.append("cus_email", this.cus_email);
      form.append("cus_phone", this.cus_phone);

      this.closeModal();

      if (payment_type == "ssl") {
        form.append("amount", takenAmount);
        form.append("custom_amount", takenAmount);
        form.append("taken_amount", takenAmount);

        if (takenAmount < this.currency_bdt.min_donate_amount) {
          swal(
            "Minimum Amount is " +
              this.currency_bdt.min_donate_amount +
              " Taka",
            "",
            "error"
          );
          return;
        }

        if (takenAmount > this.currency_bdt.max_donate_amount) {
          swal(
            "Maximum Amount is " +
              this.currency_bdt.max_donate_amount +
              " Taka",
            "",
            "error"
          );
          return;
        }

        this.sslPayment(form);
      }

      if (payment_type == "paypal") {
        var minimumConvertedDonateAmount =
          this.currency_usd.min_donate_amount *
          this.currency_usd.tk_convert_amount;

        var maxmumConvertedDonateAmount =
          this.currency_usd.max_donate_amount *
          this.currency_usd.tk_convert_amount;

        //console.log(maxmumConvertedDonateAmount)

        if (takenAmount < minimumConvertedDonateAmount) {
          swal(
            "Minimum Amount is " + minimumConvertedDonateAmount + " Taka",
            "",
            "error"
          );
          return;
        }

        if (takenAmount > maxmumConvertedDonateAmount) {
          swal(
            "Maximum Amount is " + maxmumConvertedDonateAmount + " Taka",
            "",
            "error"
          );
          return;
        }

        var convertedAmount = takenAmount / this.currency_usd.tk_convert_amount;

        form.append("amount", convertedAmount);
        form.append("custom_amount", convertedAmount);
        form.append("taken_amount", convertedAmount);

        this.paypalPayment(form);
      }
    },

    sslPayment(form) {
      delete axios.defaults.headers.common["Authorization"];
      var config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      var childWindow = window.open(appRootUrl + "/loading", "_blank");
      axios
        .post(adminPanelUrl + "/vue_client_pay_with_sslcommerz", form, config)
        .then(function(response) {
          //console.log(response.data);
          // window.open(
          //   response.data,
          //   '_blank'
          // );
          childWindow.location.href = response.data;
        })
        .catch(function(error) {
          let alertmessage = "";
          for (var prop in error.response.data) {
            alertmessage += " " + error.response.data[prop];
          }
          //console.log(alertmessage)
          swal(alertmessage, "", "error");
        });
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("token");
    },

    paypalPayment(form) {
      delete axios.defaults.headers.common["Authorization"];
      var config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      var childWindow = window.open(appRootUrl + "/loading", "_blank");

      axios
        .post(adminPanelUrl + "/vue_client_pay_with_paypal", form, config)
        .then(function(response) {
          //console.log(response.data);
          // window.open(
          //   response.data,
          //   '_blank'
          // );
          childWindow.location.href = response.data;
        })
        .catch(function(error) {
          let alertmessage = "";
          for (var prop in error.response.data) {
            alertmessage += " " + error.response.data[prop];
          }
          //console.log(alertmessage)
          swal(alertmessage, "", "error");
        });
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("token");
    },
  },
  computed: {},
  created() {
    var SponsorDetailsID = this.$route.params.id;
    axios
      .get(apiResourceUrl + "/sponsor-details/" + SponsorDetailsID)
      .then((response) => {
        this.studentData = response.data.student;
        this.currency_bdt = response.data.currency_bdt;
        this.currency_usd = response.data.currency_usd;

        this.loadAmount(
          parseInt((this.studentData.scholarship_amount / 12) * 1)
        );

        //console.log(response.data);
      });
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.donate-left-section {
  text-align: justify;
}
</style>
